var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('issuable-card',{attrs:{"issuable-controller":_vm.issuableController()},scopedSlots:_vm._u([{key:"issuable-card",fn:function(ref){
var itemScope = ref.itemScope;
return [_c('dea-license-detail',{attrs:{"deaLicense":itemScope.issuable,"issuableController":itemScope.issuableController},on:{"deaLicenseSelected":itemScope.closeOthers,"staleData":itemScope.fetchAll,"cancel":itemScope.cancel}})]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c4bd98c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/provider/cards/deaLicense/DEALicenseCard.vue
// module id = null
// module chunks = 